<template>
  <div>
    <v-card-text class="pa-0" style="height: 600px; overflow-y: auto;">
      <v-layout class="pa-2" row wrap style="height: auto;" v-if="device">

        <!-- Vasen -->
        <v-flex xs6 style="padding-bottom: 5px;" pr-1>
          <v-autocomplete label="Type" :items="device_types" v-model="device.type" item-text="title" item-value="name"></v-autocomplete>
          <v-text-field v-model="device.identifier"  label="Identifier"></v-text-field>

          <div v-if="device_type">
            <v-layout row>
              <v-flex xs6>
                <select-content-list :clearable="false" label="Status" :list_id="device_type.value.status_list_id" v-model="device.status_id" item-value="id" item-text="name"></select-content-list>
              </v-flex>
              <v-flex xs6>
                <select-content-list :clearable="false" label="Usage" :list_id="device_type.value.usage_list_id" v-model="device.usage_id" item-value="id" item-text="name"></select-content-list>
              </v-flex>
            </v-layout>
            <select-content-list :clearable="false" label="Location" :list_id="device_type.value.location_list_id" v-model="device.location_id" item-value="id" item-text="name"></select-content-list>
            <select-content-list :clearable="false" label="Series" :list_id="device_type.value.series_list_id" v-model="device.series_id" item-value="id" item-text="name"></select-content-list>
          </div>

          <div v-if="!is_multiple_parents_subdevice">
            Subdevices:
            <v-layout row>
              <v-flex xs10>
                <v-autocomplete :items="filtered_devices" v-model="subdevice" label="Device" item-text="identifier" item-value="id" :search-input.sync="search_subdevice_input" @keyup.enter="enter_subdevice" ref="subdeviceSelect"></v-autocomplete>
              </v-flex>
              <v-flex xs2>
                <v-btn class="success" @click="add_subdevice()">Add</v-btn>
              </v-flex>
            </v-layout>
            <template v-for="(id,idx) in subdevices">
              <v-chip>
                {{devices_map[id]["identifier"]}}
                <v-icon right @click.stop="del_subdevice(idx)" v-if="!is_device_multiple_parents_subdevice(devices_map[id])">cancel</v-icon>
              </v-chip>
            </template>
          </div>

          <div v-if="!is_multiple_parents_subdevice">
            Instances:
            <v-layout row>
              <v-flex xs10>
                <v-autocomplete :items="all_instances" v-model="instance" label="Instance" item-text="title" item-value="id" :search-input.sync="search_instance_input" @keyup.enter="enter_instance" ref="instanceSelect"></v-autocomplete>
              </v-flex>
              <v-flex xs2>
                <v-btn class="success" @click="add_instance()">Add</v-btn>
              </v-flex>
            </v-layout>
            <template v-for="(id,idx) in instances">
              <v-chip>
                {{instances_map[id]["title"]}}
                <v-icon right @click.stop="del_instance(idx)">cancel</v-icon>
              </v-chip>
            </template>
          </div>

          <div class="pb-2">
            Identifier QR-code:
            <div class="mt-2" style="width: 220px; height: 220px; background-color: white;">
              <qrcode-vue @hook:mounted="qrcode_mounted" v-show="false" v-model="device.identifier" :size="200"></qrcode-vue>
              <img ref="qrcode" style="margin: 10px; width: 200px; height: 200px;">
            </div>
          </div>

        </v-flex>

        <!-- Oikea -->
        <v-flex xs6>
          <div v-if="device_type">
            <component v-for="elem in form" :key="elem.name" v-bind:is="elem.type" v-bind="elem" v-model="device.form_data">
              <v-flex :class="row_classes(elem.childs)" v-for="celem in elem.childs" :key="celem.key">
                <component v-bind:is="celem.type" v-bind="celem" v-model="device.form_data"></component>
              </v-flex>
            </component>
          </div>
        </v-flex>

      </v-layout>
    </v-card-text>

    <!-- Actions -->
    <v-card-actions style="background-color: #3A3A3A; min-height: 85px;">
      <v-text-field label="Comment" v-model="device_log.meta.comment" style="width: 100%;"></v-text-field>
      <v-spacer></v-spacer>
      <v-btn flat @click="reset">Reset</v-btn>
      <v-btn color="success" @click="save(false)">Save</v-btn>
      <v-btn color="success" @click="save(true)">Save and close</v-btn>
    </v-card-actions>

  </div>
</template>


<script>
import * as FormItems from '@/components/form_items'
import SettingsModel from '@/models/settings.js';
import SelectContentList from '@/components/SelectContentList'
import QrcodeVue from 'qrcode.vue';
export default {
  props: ["id"],

  data () {
    var ch = this.$cloudserver.channel("devices:"+(this.id||"create"));
    return {
      ws_channel: ch,
      device: this.convertDevice(ch.data),
      device_log: {meta: {}},
      subdevice: undefined,
      subdevices: ch.data.sub_device_list,
      instance: undefined,
      instances: ch.data.instance_list,
      search_subdevice_input: "",
      search_instance_input: ""
    }
  },
  components: {
    SelectContentList,
    QrcodeVue,
    ...FormItems
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.device = this.convertDevice(newVal, oldVal);
          this.instances = this.device.instance_list;
          this.subdevices = this.device.sub_device_list;
        }
      },
      deep: true
    },
    '$route' (to, from) {
      if(typeof(from.meta.edit) != "undefined" && to.name == from.meta.edit) {
        this.ws_channel = this.$cloudserver.channel("devices:"+(this.id||"create"));
        this.ws_channel.join();
      }
    }
  },
  created() {
    this.ws_channel.join();
  },
  computed: {
    filtered_devices() {
      return _.filter(this.devices, (device) => {
        if(this.is_device_multiple_parents_subdevice(device)) return false;
        return device.id != this.device.id;
      });
    },
    devices () {
      return Object.values(this.$store.state.devices)
    },
    all_instances () {
      return Object.values(this.$store.state.instances);
    },
    devices_map () {
      return this.$store.state.devices;
    },
    instances_map () {
      return this.$store.state.instances;
    },
    device_types () {
      return SettingsModel.list("device_type");
    },
    device_type () {
      if (typeof(this.device.type) != "undefined") {
        return SettingsModel.get_by_name(this.device.type);
      }
      return undefined;
    },
    is_multiple_parents_subdevice() {
      return this.is_device_multiple_parents_subdevice(this.device);
    },
    form () {
      return _.filter(_.get(this.device_type, "value.form", []) || [], (field) => {
        console.log(field)
        if(this.is_multiple_parents_subdevice && field.multiple_parents_field) return false;
        return true;
      });
    },
  },
  methods: {
    is_device_multiple_parents_subdevice(item) {
      return _.get(item, ["meta", "multiple_parents_subdevice"], false);
    },
    enter_subdevice() {
      var subdevice = _.find(this.filtered_devices, (device) => {
        return device.identifier == this.search_subdevice_input;
      });

      if (typeof(subdevice) != "undefined") {
        this.subdevice = subdevice.id;
        this.add_subdevice();
        this.search_subdevice_input = "";
        this.$refs.subdeviceSelect.isMenuActive = false;

      }
    },
    add_subdevice() {
      if (typeof(this.subdevice) != "undefined" && this.subdevice != null) {
        var new_list = this.subdevices;
        new_list.push(this.subdevice);
        this.subdevices = new_list;
        this.subdevice = undefined;
      }
    },
    del_subdevice(idx) {
      var new_list = this.subdevices;
      new_list.splice(idx,1);
      this.subdevices = new_list;
    },
    enter_instance() {
      var instance = _.find(this.all_instances, (instance) => {
        return instance.title == this.search_instance_input;
      });

      if (typeof(instance) != "undefined") {
        this.instance = instance.id;
        this.add_instance();
        this.search_instance_input = "";
        this.$refs.instanceSelect.isMenuActive = false;
      }
    },

    add_instance() {
      if (typeof(this.instance) != "undefined" && this.instance != null) {
        var new_list = this.instances;
        new_list.push(this.instance);
        new_list = _.uniq(new_list);
        this.instances = new_list;
        this.instance = undefined;
      }
    },
    del_instance(idx) {
      var new_list = this.instances;
      new_list.splice(idx,1);
      this.instances = new_list;
    },
    qrcode_mounted() {
      this.$nextTick(() => {
        const canvas = document.querySelector('canvas');
        const img    = canvas.toDataURL('image/png');
        this.$refs.qrcode.src = img;
      });
    
    },

    convertDevice (newVal, oldVal) {
      var device = _.cloneDeep(newVal);
      if(typeof(oldVal) != "undefined") {
        //TODO: Tähän muuttuneen datan tarkistus ja ilmoitus
      }
      if(typeof(device) == "undefined" || _.isEmpty(device)) return undefined;

      return device;
    },
    archive () {

    },
    reset () {
      this.device = this.convertDevice(this.ws_channel.data);
    },
    save (close) {
      var self = this;
      if (typeof(this.ws_channel) != "undefined") {
        var device = _.cloneDeep(this.device);

        this.ws_channel.save({device: device, device_log: this.device_log, subdevices: this.subdevices, instances: this.instances})
          .then((msg) => {
            if (typeof(self.id) == "undefined") {
              self.$message.success("Device was created!");
            } else {
              self.$message.success("Device was updated!");
            }
            if(close) {
              self.$root.close_bottom_sheet();
            } else if(typeof(self.id) == "undefined" && typeof(this.$route.meta.edit) != "undefined") {
              this.$router.push({name: this.$route.meta.edit, params: {id: msg.data.id}})
            }
          })
          .catch((msg) => {
            console.log(msg);
            if (typeof(self.id) == "undefined") {
              self.$message.warning("Unable to create device!");
            } else {
              self.$message.warning("Unable to update device!");
            }
          });
      }
    },
  }

}
</script>